import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import IconButton from '../../../../icon-button';
import IconItem from '../../icon-item';
import MathContent from '../../../../math-content';

import IconError from '../../assets/stroked-circle-cross.svg';
import IconSuccess from '../../assets/stroked-circle-check.svg';
import IconWarning from '../../assets/exclamation-circle.svg';
import { Show } from '../../../../show';

import { VALIDATION_STATUSES } from '../../../../../lib/checker';

const ICONS_COLORS = {
    [VALIDATION_STATUSES.ERROR]: 'text-error-red-main',
    [VALIDATION_STATUSES.VALID]: 'text-success-green-main',
    [VALIDATION_STATUSES.MISSING]: 'text-grey-800',
};

const ICONS = {
    [VALIDATION_STATUSES.ERROR]: IconError,
    [VALIDATION_STATUSES.VALID]: IconSuccess,
    [VALIDATION_STATUSES.MISSING]: IconWarning,
};

const IconsContainer = styled.div`
    display: inline-flex;
`;

export const ActionIcon = styled(IconItem)`
    ${({ theme }) => css`
        width: 18px;
        height: 18px;
        fill: ${theme.colors['text-myzanichelli-blue-main']};

        &:hover {
            fill: ${theme.colors['text-myzanichelli-blue-dark']};
        }
    `}
`;

// prettier-ignore serve a permettere solo in questo caso l'utilizzo delle " in mask
const Correction = styled.div`
    ${({ theme, validation }) => css`
        display: flex;
        align-items: center;
        padding-left: 8px;
        padding-right: 8px;

        /* prettier-ignore */
        &:before {
            background: ${theme.colors[ICONS_COLORS[validation]]};
            content: ' ';
            height: 18px;
            width: 18px;
            mask: url("${ICONS[validation]}") no-repeat center;
            mask-size: contain;
        }
    `}
`;

export const Question = styled(MathContent)`
    overflow-x: auto;
    line-height: 32px;
    font-size: 14px;
`;

const NotEditableBox = ({ content, isCorrection, validation, onClick }) => {
    return (
        <>
            <Question>{content}</Question>
            <IconsContainer>
                <Show when={!isCorrection}>
                    <IconButton type="tertiary" size="xsmall" onClick={onClick}>
                        <ActionIcon name="edit"></ActionIcon>
                    </IconButton>
                </Show>

                <Show when={validation}>
                    <Correction validation={validation} />
                </Show>
            </IconsContainer>
        </>
    );
};

NotEditableBox.propTypes = {
    content: PropTypes.string,
    validation: PropTypes.any,
    onClick: PropTypes.func,
    isCorrection: PropTypes.bool,
};

export default NotEditableBox;
